import Cookie from "js-cookie";
import { GEOIP_COUNTRY_COOKIE } from "../../../common/constants/Constants";

function setCountryCookie(country?: string): void {
    if (!country) {
        return;
    }

    Cookie.set(GEOIP_COUNTRY_COOKIE, country, {
        domain: ".bloomberg.com"
    });
}

export default setCountryCookie;
